import { GroupingCodeComboBoxComponent } from './grouping-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * ECグルーピングコンボボックスモデル
 *
 * @export GroupingCodeComboBoxModel
 * @class GroupingCodeComboBoxModel
 */
export class GroupingCodeComboBoxModel {

  /**
   * リスト
   */
   public groupingList: Array<any>;
   // 先頭空白表示
   public blank: boolean = <boolean>true;
   // コードリスト取得完了
   public completeUpdateFlg: boolean = <boolean>false;
   // 初期設定コード値
   public setGroupingCode: string = null;
   // 初期データ自動取得フラグ
   public initAutoLoad: boolean = <boolean>true;
   // コンボボックスインスタンス
   public component: GroupingCodeComboBoxComponent;

   /**
    * リスト更新する
    *
    * @param serverData サーバ取得データ
    */
   public updateGroupingList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

     // 先頭空白追加
     if (this.blank) {
       tempDataList.splice(index, 0, this.getBlankObject());
       index = <number>1;
     }

     // コード+：+名称追加
     for (; index < tempDataList.length; index++) {
       tempDataList[index].GroupingCodeName =
        tempDataList[index].GroupingCode + ':' + tempDataList[index].GroupingName;
     }

     this.groupingList = tempDataList;

     this.completeUpdateFlg = <boolean>true;
     this.component.updateSelectedGroupingCode();
   }

   /**
    * 空白のオブジェクトを取得する
    * @return Object:オブジェクト
    */
   private getBlankObject(): object {
     const ob: any = {};
     ob.GroupingCode = '';
     ob.GroupingName = '';
     ob.GroupingCodeName = '';
     return ob;
   }

}
